import { useMutation, useQueryClient } from "@tanstack/react-query";
import fetchToBackend, { type BackendError } from "@/utils/fetchToBackend";
import { onboardingKeys } from "@/lib/query-keys";

/** Sube un documento en el onboarding. Va en base64, igual que en Configuración. */
export function useUploadOnboardingDocument() {
  const qc = useQueryClient();
  return useMutation<{ id: number }, BackendError, { fileName: string; base64Data: string }>({
    mutationFn: (input) =>
      fetchToBackend("/onboarding/documents", {
        method: "POST",
        body: JSON.stringify(input),
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: onboardingKeys.documents() }),
  });
}

/** Arranca los 5 cruces de prueba; lo ya cruzado con los mismos documentos se reusa. */
export function useStartOnboardingQualification() {
  const qc = useQueryClient();
  return useMutation<{ started: boolean }, BackendError, { searchProfileId: number }>({
    mutationFn: (input) =>
      fetchToBackend("/onboarding/qualification", {
        method: "POST",
        body: JSON.stringify(input),
      }),
    onSettled: () => qc.invalidateQueries({ queryKey: onboardingKeys.qualification() }),
  });
}
